export default {
  enquiry: {
    loading: false,
    error: null,
    data: null,
  },
};
